import { isMainNet } from "../utils/config";
import { NETWORKS_MAINNET, NETWORKS_TESTNET } from "../utils/constants";
import useWalletConnect from "../utils/hooks/useWalletConnect";
import Modal from "./Modal";

export default function CopyModal({ onClose }) {
  const { changeNetwork } = useWalletConnect();

    const switchNetwork=()=>{
        const bscChainId =
        isMainNet === "true"
          ? NETWORKS_MAINNET['BSC']
          : NETWORKS_TESTNET['BSC'];
    changeNetwork(bscChainId)
    }
  return (
    <Modal close={onClose} showCloseIcon={false} addClass={'switchModal'}>
      <div
        className="modal__invoice"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          <img
            style={{
              width: "76px",
              height: "auto",
              margin: "0 auto",
              display: "block",
              marginBottom: "25px",
            }}
            src={process.env.PUBLIC_URL + "/images/information-icon.png"}
            alt="congrats"
          />
          <h4
            style={{
              marginBottom: "25px",
              color: "#fff",
              fontWeight: 800,
              letterSpacing: "-1.5px",
            }}
          >
            Wrong Network!
          </h4>

          <p
            style={{
              marginBottom: "20px",
            }}
          >
            Please select to appropriate BSC network
          </p>

          <div className="btn bg-transparent lineHeight btn-block">
            <button
            onClick={switchNetwork}
              type="button"
              style={{
                backgroundColor: "#ff5757",
                display: "block",
                width: "400px",
                fontSize: "1.25rem",
                padding: "1rem",
                border: "1px solid #ff5757",
                borderRadius: "15px",
                color: "#fff",
                cursor: "pointer",
                marginTop: "1rem",
                fontWeight: "bold",
                height: "50px",
              }}
            >
              Switch To BSC
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
